import $bK1z9$arAEmodulejs from "./ar-AE.mjs";
import $bK1z9$bgBGmodulejs from "./bg-BG.mjs";
import $bK1z9$csCZmodulejs from "./cs-CZ.mjs";
import $bK1z9$daDKmodulejs from "./da-DK.mjs";
import $bK1z9$deDEmodulejs from "./de-DE.mjs";
import $bK1z9$elGRmodulejs from "./el-GR.mjs";
import $bK1z9$enUSmodulejs from "./en-US.mjs";
import $bK1z9$esESmodulejs from "./es-ES.mjs";
import $bK1z9$etEEmodulejs from "./et-EE.mjs";
import $bK1z9$fiFImodulejs from "./fi-FI.mjs";
import $bK1z9$frFRmodulejs from "./fr-FR.mjs";
import $bK1z9$heILmodulejs from "./he-IL.mjs";
import $bK1z9$hrHRmodulejs from "./hr-HR.mjs";
import $bK1z9$huHUmodulejs from "./hu-HU.mjs";
import $bK1z9$itITmodulejs from "./it-IT.mjs";
import $bK1z9$jaJPmodulejs from "./ja-JP.mjs";
import $bK1z9$koKRmodulejs from "./ko-KR.mjs";
import $bK1z9$ltLTmodulejs from "./lt-LT.mjs";
import $bK1z9$lvLVmodulejs from "./lv-LV.mjs";
import $bK1z9$nbNOmodulejs from "./nb-NO.mjs";
import $bK1z9$nlNLmodulejs from "./nl-NL.mjs";
import $bK1z9$plPLmodulejs from "./pl-PL.mjs";
import $bK1z9$ptBRmodulejs from "./pt-BR.mjs";
import $bK1z9$ptPTmodulejs from "./pt-PT.mjs";
import $bK1z9$roROmodulejs from "./ro-RO.mjs";
import $bK1z9$ruRUmodulejs from "./ru-RU.mjs";
import $bK1z9$skSKmodulejs from "./sk-SK.mjs";
import $bK1z9$slSImodulejs from "./sl-SI.mjs";
import $bK1z9$srSPmodulejs from "./sr-SP.mjs";
import $bK1z9$svSEmodulejs from "./sv-SE.mjs";
import $bK1z9$trTRmodulejs from "./tr-TR.mjs";
import $bK1z9$ukUAmodulejs from "./uk-UA.mjs";
import $bK1z9$zhCNmodulejs from "./zh-CN.mjs";
import $bK1z9$zhTWmodulejs from "./zh-TW.mjs";

var $df39c1238ae2b5f3$exports = {};


































$df39c1238ae2b5f3$exports = {
    "ar-AE": $bK1z9$arAEmodulejs,
    "bg-BG": $bK1z9$bgBGmodulejs,
    "cs-CZ": $bK1z9$csCZmodulejs,
    "da-DK": $bK1z9$daDKmodulejs,
    "de-DE": $bK1z9$deDEmodulejs,
    "el-GR": $bK1z9$elGRmodulejs,
    "en-US": $bK1z9$enUSmodulejs,
    "es-ES": $bK1z9$esESmodulejs,
    "et-EE": $bK1z9$etEEmodulejs,
    "fi-FI": $bK1z9$fiFImodulejs,
    "fr-FR": $bK1z9$frFRmodulejs,
    "he-IL": $bK1z9$heILmodulejs,
    "hr-HR": $bK1z9$hrHRmodulejs,
    "hu-HU": $bK1z9$huHUmodulejs,
    "it-IT": $bK1z9$itITmodulejs,
    "ja-JP": $bK1z9$jaJPmodulejs,
    "ko-KR": $bK1z9$koKRmodulejs,
    "lt-LT": $bK1z9$ltLTmodulejs,
    "lv-LV": $bK1z9$lvLVmodulejs,
    "nb-NO": $bK1z9$nbNOmodulejs,
    "nl-NL": $bK1z9$nlNLmodulejs,
    "pl-PL": $bK1z9$plPLmodulejs,
    "pt-BR": $bK1z9$ptBRmodulejs,
    "pt-PT": $bK1z9$ptPTmodulejs,
    "ro-RO": $bK1z9$roROmodulejs,
    "ru-RU": $bK1z9$ruRUmodulejs,
    "sk-SK": $bK1z9$skSKmodulejs,
    "sl-SI": $bK1z9$slSImodulejs,
    "sr-SP": $bK1z9$srSPmodulejs,
    "sv-SE": $bK1z9$svSEmodulejs,
    "tr-TR": $bK1z9$trTRmodulejs,
    "uk-UA": $bK1z9$ukUAmodulejs,
    "zh-CN": $bK1z9$zhCNmodulejs,
    "zh-TW": $bK1z9$zhTWmodulejs
};


export {$df39c1238ae2b5f3$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
